import Page from '../page';

import moduleAboutAboutHeliumHero from '../../module/about/about-helium/hero';
import moduleAboutAboutHeliumSemiconductors from '../../module/about/about-helium/semiconductors';
import moduleAboutAboutHeliumFiber from '../../module/about/about-helium/fiber';
import moduleAboutAboutHeliumMri from '../../module/about/about-helium/mri';
import moduleAboutAboutHeliumAerospace from '../../module/about/about-helium/aerospace';
import moduleAboutAboutHeliumDiving from '../../module/about/about-helium/diving';
import moduleAboutAboutHeliumWelding from '../../module/about/about-helium/welding';
import moduleAboutAboutHeliumDetection from '../../module/about/about-helium/detection';
import moduleAboutAboutHeliumAutomotive from '../../module/about/about-helium/automotive';
import moduleAboutAboutHeliumDrives from '../../module/about/about-helium/drives';
import moduleAboutAboutHeliumAirships from '../../module/about/about-helium/airships';
import moduleAboutAboutHeliumFusion from '../../module/about/about-helium/fusion';


import jumpFactory from '../../libs/jump/jump';
import binder from '../../libs/utils/binder';
import router from '../../libs/router/router';

interface ExtAboutAboutHeliumPageConfigInterface {
	cssId: {
		headerCls: string;
		layout: {
			navigateTargetId: string;
			canNavigateCls: string;
			headerMenuItemCls: string;
			headerMenuItemActiveCls: string;
		};
	};
	startModule: string;
	startModuleSlug: string;
	baseUrl: string;
	currentUrl: string;
	moduleHeroConfig?: ConfigInterface;
	moduleSemiconductorsConfig?: ConfigInterface;
	moduleFiberConfig?: ConfigInterface;
	moduleMriConfig?: ConfigInterface;
	moduleAerospaceConfig?: ConfigInterface;
	moduleDivingConfig?: ConfigInterface;
	moduleWeldingConfig?: ConfigInterface;
	moduleDetectionConfig?: ConfigInterface;
	moduleAutomotiveConfig?: ConfigInterface;
	moduleDrivesConfig?: ConfigInterface;
	moduleAirshipsConfig?: ConfigInterface;
	moduleFusionConfig?: ConfigInterface;

	trackAdd?: {
		[key: string]: string;
	};
}

interface ConfigInterface {
	cssId: {
		[key: string]: string;
	},
	slug: string;
	trackAdd?: {};
}

interface ServiceInterface {
	jump?: ReturnType<typeof jumpFactory.create>;
}

interface ItemsInterface {
	init: boolean;
	module: (typeof moduleAboutAboutHeliumHero | typeof moduleAboutAboutHeliumSemiconductors | typeof moduleAboutAboutHeliumFiber
		| typeof moduleAboutAboutHeliumMri | typeof moduleAboutAboutHeliumAerospace | typeof moduleAboutAboutHeliumDiving
		| typeof moduleAboutAboutHeliumWelding | typeof moduleAboutAboutHeliumDetection | typeof moduleAboutAboutHeliumAutomotive
		| typeof moduleAboutAboutHeliumDrives | typeof moduleAboutAboutHeliumAirships | typeof moduleAboutAboutHeliumFusion);
	config: ConfigInterface;
	callbacks: {};
}

declare global {
	interface Window {
		extAboutAboutHeliumPageConfig: ExtAboutAboutHeliumPageConfigInterface;
	}
}

class AboutAboutHeliumPage extends Page {

	publicVars: ExtAboutAboutHeliumPageConfigInterface;
	service: ServiceInterface = {};

	privateVars: {
		items: Map<string, ItemsInterface>;
		itemsKeys: string[];
		canNavigateAction: (0 | 1);
		targetSection: string;
		currentMenuItem: string;
	} = {
		items: new Map(),
		itemsKeys: [],
		canNavigateAction: 0,
		targetSection: '',
		currentMenuItem: ''
	};

	constructor() {
		super('AboutAboutHeliumPage');
		this.publicVars = window['extAboutAboutHeliumPageConfig'];
		this.privateVars.canNavigateAction = 0;
		this.privateVars.currentMenuItem = this.publicVars.startModule;
	}

	startup() {
		this.msg('startup');

		this.service.jump = jumpFactory.create();
		this.service.jump.init();

		this.privateVars.items = new Map();

		if (this.publicVars.moduleHeroConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__hero');

			this.privateVars.items.set('about-about-helium__hero', {
				init: false,
				module: moduleAboutAboutHeliumHero,
				config: this.publicVars.moduleHeroConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleSemiconductorsConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__semiconductors');

			this.privateVars.items.set('about-about-helium__semiconductors', {
				init: false,
				module: moduleAboutAboutHeliumSemiconductors,
				config: this.publicVars.moduleSemiconductorsConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleFiberConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__fiber');

			this.privateVars.items.set('about-about-helium__fiber', {
				init: false,
				module: moduleAboutAboutHeliumFiber,
				config: this.publicVars.moduleFiberConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleMriConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__mri');

			this.privateVars.items.set('about-about-helium__mri', {
				init: false,
				module: moduleAboutAboutHeliumMri,
				config: this.publicVars.moduleMriConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleAerospaceConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__aerospace');

			this.privateVars.items.set('about-about-helium__aerospace', {
				init: false,
				module: moduleAboutAboutHeliumAerospace,
				config: this.publicVars.moduleAerospaceConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleDivingConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__diving');

			this.privateVars.items.set('about-about-helium__diving', {
				init: false,
				module: moduleAboutAboutHeliumDiving,
				config: this.publicVars.moduleDivingConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleWeldingConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__welding');

			this.privateVars.items.set('about-about-helium__welding', {
				init: false,
				module: moduleAboutAboutHeliumWelding,
				config: this.publicVars.moduleWeldingConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleDetectionConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__detection');

			this.privateVars.items.set('about-about-helium__detection', {
				init: false,
				module: moduleAboutAboutHeliumDetection,
				config: this.publicVars.moduleDetectionConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleAutomotiveConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__automotive');

			this.privateVars.items.set('about-about-helium__automotive', {
				init: false,
				module: moduleAboutAboutHeliumAutomotive,
				config: this.publicVars.moduleAutomotiveConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleDrivesConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__drives');

			this.privateVars.items.set('about-about-helium__drives', {
				init: false,
				module: moduleAboutAboutHeliumDrives,
				config: this.publicVars.moduleDrivesConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleAirshipsConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__airships');

			this.privateVars.items.set('about-about-helium__airships', {
				init: false,
				module: moduleAboutAboutHeliumAirships,
				config: this.publicVars.moduleAirshipsConfig,
				callbacks: {}
			});
		}

		if (this.publicVars.moduleFusionConfig) {
			this.privateVars.itemsKeys.push('about-about-helium__fusion');

			this.privateVars.items.set('about-about-helium__fusion', {
				init: false,
				module: moduleAboutAboutHeliumFusion,
				config: this.publicVars.moduleFusionConfig,
				callbacks: {}
			});
		}


		if (this.publicVars.startModule !== '' && this.publicVars.startModule !== 'about-about-helium__hero') {
			this.performNavigate(this.publicVars.startModule, {
				fireAnim: 1
			});
		} else {
			this.handleCurrentScrollPosition();
		}
	}

	bind() {
		this.msg('bind');

		let ticking = false;

		window.addEventListener('beforeunload', (e)=> {
			//alert('abc');
			//view.privateVars.canNavigateAction = 1;

			if (this.privateVars.currentMenuItem != 'about-about-helium__hero' && this.privateVars.currentMenuItem != '') {

				const elementHtml = document.querySelector(this.publicVars.cssId.layout.navigateTargetId + '-' + this.privateVars.currentMenuItem) as HTMLElement;
				const headerElementHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;

				const elementPos = elementHtml.getBoundingClientRect();
				const headerPos = headerElementHtml.getBoundingClientRect();

				window.scroll(0, elementPos.top + window.scrollY - headerPos.height);
			}
		});

		window.addEventListener('scroll', () => {
			if (this.privateVars.canNavigateAction === 0) {
				if (!ticking) {
					window.requestAnimationFrame(() => {
						this.handleCurrentScrollPosition();
						ticking = false;
					});
				}
				ticking = true;
			}
		});

		window.addEventListener('resize', () => {
			this.handleCurrentScrollPosition();
		});

		window.addEventListener('orientationchange', () => {
			this.handleCurrentScrollPosition();
		});

		binder.bindToAll('click', this.publicVars.cssId.layout.canNavigateCls, (e: Event) => {
			e.preventDefault();

			const element = e.currentTarget as HTMLElement;
			const target = element.dataset.target;

			this.msg('navigate target ' + target);

			if(target) {
				this.performNavigate(target, { fireAnim: 1 });
			}
		});
	}

	handleCurrentScrollPosition(options?: {
		target?: string;
	}) {
		const systemCurrentScroll = document.documentElement.scrollTop || window.scrollY;

		let currentMenu;

		const cssHeaderHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;
		const cssHeaderHeight = cssHeaderHtml.offsetHeight;

		let continueFindMenuItem = true;
		let lastItemOffsetHeight = 0;

		for (let [key, _value] of this.privateVars.items) {

			let cssNavigateTargetHtml = document.querySelector(this.publicVars.cssId.layout.navigateTargetId + '-' + key);

			if(!cssNavigateTargetHtml) {
				this.errorMsg('navigate target not found ' + key);
				continue;
			}

			let targetPos = {
				top: cssNavigateTargetHtml.getBoundingClientRect().top + window.scrollY,
				left: cssNavigateTargetHtml.getBoundingClientRect().left + window.scrollX
			};

			this.handleModuleInit(systemCurrentScroll, key, targetPos);

			if (continueFindMenuItem) {
				if (systemCurrentScroll === 0) {
					currentMenu = key;
					continueFindMenuItem = false;
				} else {

					const windowHeight = window.innerHeight;

					let modifierDivisionValue = (lastItemOffsetHeight > windowHeight) ? windowHeight : lastItemOffsetHeight;

					let modifier = modifierDivisionValue / 2;

					if ((targetPos.top - cssHeaderHeight - modifier) < systemCurrentScroll) {
						currentMenu = key;
					}
				}
			}

			const targetElementHtml = document.querySelector(this.publicVars.cssId.layout.navigateTargetId + '-' + key) as HTMLElement;

			lastItemOffsetHeight = targetElementHtml.offsetHeight;
		}

		if (options && options.target) {
			currentMenu = options.target;
		}

		// if (this.privateVars.currentMenuItem !== currentMenu) {
		//
		// 	if(this.privateVars.currentMenuItem !== '' && this.privateVars.currentMenuItem !== 'home__hero') {
		// 		const oldHeaderMenuItemHtml = document.querySelector(
		// 			this.publicVars.cssId.headerCls + ' a[data-target="' + this.privateVars.currentMenuItem +
		// 			'"]') as HTMLElement;
		// 		oldHeaderMenuItemHtml.classList.remove(this.publicVars.cssId.layout.headerMenuItemActiveCls.substring(1));
		// 	}
		//
		// 	if(currentMenu !== '' && currentMenu !== 'home__hero') {
		// 		const newHeaderMenuItemHtml = document.querySelector(
		// 			this.publicVars.cssId.headerCls + ' a[data-target="' + currentMenu + '"]') as HTMLElement;
		// 		newHeaderMenuItemHtml?.classList.add(this.publicVars.cssId.layout.headerMenuItemActiveCls.substring(1));
		// 	}
		//
		// 	const currentElementHtml = document.querySelector(
		// 		this.publicVars.cssId.layout.navigateTargetId + '-' + currentMenu) as HTMLElement;
		//
		// 	this.privateVars.currentMenuItem = currentMenu ?? '';
		// 	let metaTitle = currentElementHtml.dataset['meta.title'] ?? '';
		//
		// 	let targetUrl = this.publicVars.baseUrl;
		//
		// 	if (targetUrl.slice(-1) === '/') {
		// 		targetUrl = targetUrl.substring(0, targetUrl.length - 1);
		// 	}
		//
		// 	let trackAdd;
		//
		// 	if (currentMenu && currentMenu !== '' && this.privateVars.items.get(currentMenu)?.config.slug) {
		// 		targetUrl = targetUrl + '/' + this.privateVars.items.get(currentMenu)?.config.slug;
		// 	}
		//
		// 	if (currentMenu && currentMenu !== '' && this.privateVars.items.get(currentMenu)?.config.trackAdd) {
		// 		trackAdd = this.privateVars.items.get(currentMenu)?.config.trackAdd;
		// 	}
		//
		// 	router.route(targetUrl, metaTitle, { disableTrackForUrl: this.publicVars.currentUrl, trackAdd: trackAdd, pageName: 'home' });
		// }
	}

	handleModuleInit(currentScroll: number, key: string, targetPos: {top: number}) {

		if (this.privateVars.items && this.privateVars.items.get(key)?.module && this.privateVars.items.get(key)?.init === false) {
			const navigateTargetHtml = document.querySelector(this.publicVars.cssId.layout.navigateTargetId + '-' + key);

			if(!navigateTargetHtml) {
				this.errorMsg('navigate target not found ' + key);
				return;
			}

			const rect = navigateTargetHtml.getBoundingClientRect();
			const scrollPlusWindowHeight = document.documentElement.clientHeight + currentScroll;

			let specialModifier = 0;
			const cssHeaderHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;

			if (cssHeaderHtml) {
				specialModifier = cssHeaderHtml.offsetHeight;
			}

			if ((targetPos.top - 200) < scrollPlusWindowHeight &&
				(scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll <
					(targetPos.top + rect.height + specialModifier))) {

				this.fireModuleStart(key);

			}
		}

	}

	fireModuleStart(key: string) {

		const item = this.privateVars.items.get(key);

		if(!item) {
			return;
		}

		if (item.module && !item.init) {
			item.init = true;

			const module = item.module;
			const moduleObj = new module(item.config);
			moduleObj.init();
		}
	}

	performNavigate(target: string, options: {
		easing?: string,
		speed?: number,
		fireAnim?: number,
		detailedJumpTarget?: string,
		finishCallback?: () => void
	}) {

		if(this.privateVars.currentMenuItem !== target) {
			const oldHeaderMenuItemHtml = document.querySelector(
				this.publicVars.cssId.headerCls + ' a[data-target="' + this.privateVars.currentMenuItem +
				'"]') as HTMLElement;
			oldHeaderMenuItemHtml.classList.remove(this.publicVars.cssId.layout.headerMenuItemActiveCls.substring(1));

			const newHeaderMenuItemHtml = document.querySelector(
				this.publicVars.cssId.headerCls + ' a[data-target="' + target + '"]') as HTMLElement;

			newHeaderMenuItemHtml.classList.add(this.publicVars.cssId.layout.headerMenuItemActiveCls.substring(1));
		}

		this.privateVars.targetSection = target;
		this.fireModuleStart(target);

		let easing = (options && options.easing) || 'easeInOutExpo';

		const masterSpeed = (options && options.speed !== undefined && options.speed >= 0) ? options.speed : '';

		const cssHeaderHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;
		let modifier = -cssHeaderHtml.offsetHeight;

		let speed;

		this.privateVars.canNavigateAction = 1;

		const systemCurrentScroll = document.documentElement.scrollTop;

		let targetPos;
		let targetElemHtml;

		if (options.detailedJumpTarget) {
			targetElemHtml = document.querySelector(options.detailedJumpTarget) as HTMLElement;
		} else {
			targetElemHtml = document.querySelector(this.publicVars.cssId.layout.navigateTargetId + '-' + target) as HTMLElement;
		}

		if(!targetElemHtml) {
			this.errorMsg('navigate target not found');
			return;
		}

		targetPos = targetElemHtml.getBoundingClientRect();

		let shouldFireAnim = (options && options.fireAnim) || 0;

		let diff = Math.abs(systemCurrentScroll - targetPos.top);

		if (diff > 1000) {
			speed = 600 + (diff / 3);

		} else {
			speed = 800;
		}

		this.msg('diff for navigation ' + diff);

		if (masterSpeed !== '') {
			speed = masterSpeed;
		}

		if (shouldFireAnim === 0) {
			speed = 0;
		}

		this.msg('navigation anim speed ' + speed);

		let jumpTarget;
		let jumpMethod;

		if(!this.service.jump) {
			this.errorMsg('jump service not found');
			return;
		}

		if (options.detailedJumpTarget) {
			jumpTarget = options.detailedJumpTarget;
			jumpMethod = this.service.jump.centerTo;
		} else {
			jumpTarget = this.publicVars.cssId.layout.navigateTargetId + '-' + target;
			jumpMethod = this.service.jump.jumpTo;
		}

		jumpMethod(jumpTarget, {
			modifier: modifier,
			easing: easing,
			speed: speed
		}, () => {

			if (options.finishCallback) {
				options.finishCallback();
			}

			this.privateVars.canNavigateAction = 0;
			this.privateVars.targetSection = '';

			this.handleCurrentScrollPosition({
				target
			});
		});
	}

}

const aboutAboutHelium = new AboutAboutHeliumPage();
aboutAboutHelium.init();